module.exports = __webpack_public_path__ + "static/media/myaccount-3.5a5d751b.png";